import { assign } from 'lodash';
import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory from '../modelFactory';
import { definition, modelRules } from './sizeModelExtensions';

export interface ISize {
	depth?: number;
	height?: number;
	width?: number;
	isEmpty(): boolean;
}

const sizeFactory = modelFactory.createFactory<ISize>('Size', assign({
	depth: {
		setFilters: valueFilters.cleanNumber,
		getFilters: valueFilters.toNumber,
		rules: validator.number(true) // allow undefined
	},
	height: {
		setFilters: valueFilters.cleanNumber,
		getFilters: valueFilters.toNumber,
		rules: validator.number(true) // allow undefined
	},
	width: {
		setFilters: valueFilters.cleanNumber,
		getFilters: valueFilters.toNumber,
		rules: validator.number(true) // allow undefined
	},
	isEmpty: function () {
		return (typeof this.height === 'undefined' || this.height === 0)
			&& (typeof this.width === 'undefined' || this.width === 0)
			&& (typeof this.depth === 'undefined' || this.depth === 0);
	}
}, definition || {}), modelRules || []); 

export default sizeFactory;